module.exports = __webpack_public_path__ + "static/media/2017_composite.8a4d3889.jpg";